module.exports = __webpack_public_path__ + "img/selfAdhesive5.0398ce07.jpg";